@let homeActive = activeRoute.isActive('/'); @let prizesActive = activeRoute.isActive('/prizes'); @let newsActive = activeRoute.isActive('/news'); @let fourthActive = activeRoute.isActive(fourth().link); @let
profileActive = activeRoute.isActive('/profile');

<nav
  aria-label="Navegación principal"
  class="fixed inset-x-0 bottom-0 z-50">
  <ul
    [class]="executive() ? 'grid-cols-4' : 'grid-cols-5'"
    class="from-blue-night to-app mx-auto grid w-full max-w-[min(430px,100%)] items-end rounded-t-[20px] bg-linear-to-b pt-1 pb-[calc(1.5rem+env(safe-area-inset-bottom))]">
    <li>
      <a
        routerLink="/"
        data-test="nav-home"
        [attr.aria-current]="homeActive ? 'page' : null"
        class="after:bg-grad-nav-active aria-[current=page]:nav-item-glow relative flex flex-col items-center gap-[7px] px-1 pt-1 after:absolute after:inset-x-4 after:top-0 after:h-px after:opacity-0 after:content-[''] aria-[current=page]:after:opacity-100">
        <span class="flex h-9 items-end">
          @if (homeActive) {
          <img
            priority
            ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/menu/home.png"
            width="36"
            height="36"
            class="size-9"
            alt="" />
          } @else {
          <img
            ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/menu/home.svg"
            width="20"
            height="18"
            alt="" />
          }
        </span>

        <span
          class="text-caption leading-none"
          [class]="homeActive ? 'nav-label-active' : 'text-blue-sky font-light'">
          Home
        </span>
      </a>
    </li>

    <!-- El ejecutivo no redime ni sube tickets: en vez de premios ve el muro, y no lleva el botón central. -->
    @if (executive()) {
    <li>
      <a
        routerLink="/news"
        data-test="nav-news"
        [attr.aria-current]="newsActive ? 'page' : null"
        class="after:bg-grad-nav-active aria-[current=page]:nav-item-glow relative flex flex-col items-center gap-[7px] px-1 pt-1 after:absolute after:inset-x-4 after:top-0 after:h-px after:opacity-0 after:content-[''] aria-[current=page]:after:opacity-100">
        <span class="flex h-9 items-end">
          @if (newsActive) {
          <img
            priority
            ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/muro_novedades.png"
            width="40"
            height="43"
            class="h-9 w-auto"
            alt="" />
          } @else {
          <icon
            name="file-text"
            class="text-blue-sky"
            [size]="20" />
          }
        </span>

        <span
          class="text-caption leading-none"
          [class]="newsActive ? 'nav-label-active' : 'text-blue-sky font-light'">
          Muro
        </span>
      </a>
    </li>
    } @else {
    <li>
      <a
        routerLink="/prizes"
        data-test="nav-prizes"
        [attr.aria-current]="prizesActive ? 'page' : null"
        class="after:bg-grad-nav-active aria-[current=page]:nav-item-glow relative flex flex-col items-center gap-[7px] px-1 pt-1 after:absolute after:inset-x-4 after:top-0 after:h-px after:opacity-0 after:content-[''] aria-[current=page]:after:opacity-100">
        <span class="flex h-9 items-end">
          @if (prizesActive) {
          <img
            priority
            ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/menu/premios.png"
            width="36"
            height="36"
            class="size-9"
            alt="" />
          } @else {
          <img
            ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/menu/premios.svg"
            width="19"
            height="18"
            alt="" />
          }
        </span>

        <span
          class="text-caption leading-none"
          [class]="prizesActive ? 'nav-label-active' : 'text-blue-sky font-light'">
          Premios
        </span>
      </a>
    </li>

    <li class="flex justify-center">
      <button
        type="button"
        aria-label="Registrar producto"
        class="bg-grad-peach-gold text-app relative -top-4 grid size-15 place-items-center rounded-full shadow-[0_0_24px_rgba(127,165,208,0.35)] transition-transform duration-100 ease-out active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
        (click)="openTicketModal()">
        <icon
          name="circle-plus"
          [size]="34" />
      </button>
    </li>
    }

    <li>
      <a
        [routerLink]="fourth().link"
        data-test="nav-fourth"
        [attr.aria-current]="fourthActive ? 'page' : null"
        class="after:bg-grad-nav-active aria-[current=page]:nav-item-glow relative flex flex-col items-center gap-[7px] px-1 pt-1 after:absolute after:inset-x-4 after:top-0 after:h-px after:opacity-0 after:content-[''] aria-[current=page]:after:opacity-100">
        <span class="flex h-9 items-end">
          @if (fourthActive) {
          <img
            priority
            ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/menu/registro.png"
            width="36"
            height="36"
            class="size-9"
            alt="" />
          } @else {
          <img
            ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/menu/registro.svg"
            width="14"
            height="20"
            alt="" />
          }
        </span>

        <span
          class="text-caption leading-none"
          [class]="fourthActive ? 'nav-label-active' : 'text-blue-sky font-light'">
          {{ fourth().label }}
        </span>
      </a>
    </li>

    <li>
      <a
        routerLink="/profile"
        data-test="nav-profile"
        [attr.aria-current]="profileActive ? 'page' : null"
        class="after:bg-grad-nav-active aria-[current=page]:nav-item-glow relative flex flex-col items-center gap-[7px] px-1 pt-1 after:absolute after:inset-x-4 after:top-0 after:h-px after:opacity-0 after:content-[''] aria-[current=page]:after:opacity-100">
        <span class="flex h-9 items-end">
          @if (profileActive) {
          <img
            priority
            ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/menu/perfil.png"
            width="36"
            height="36"
            class="size-9"
            alt="" />
          } @else {
          <img
            ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/menu/perfil.svg"
            width="20"
            height="20"
            alt="" />
          }
        </span>

        <span
          class="text-caption leading-none"
          [class]="profileActive ? 'nav-label-active' : 'text-blue-sky font-light'">
          Perfil
        </span>
      </a>
    </li>
  </ul>
</nav>
